var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "none",
    stroke: "#000",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12.05 12.05 C 10.884 12.937 9.459 13.427 8 13.454 C 3.227 13.454 0.5 8 0.5 8 C 1.346 6.418 2.518 5.034 3.95 3.95 M 6.568 2.709 C 7.032 2.593 7.516 2.539 8 2.546 C 12.773 2.546 15.5 8 15.5 8 L 15.5 7.999 C 15.084 8.77 14.587 9.499 14.027 10.174 M 9.446 9.446 C 8.676 10.27 7.379 10.311 6.554 9.54 C 5.723 8.77 5.682 7.474 6.452 6.649 C 6.479 6.609 6.513 6.574 6.548 6.547",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 0.5 L 15.5 15.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.d120b90b36fe78ee78f71e08773e8636.svg";
export { ForwardRef as ReactComponent };